import React from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { DualDropDownWithSeachBar, MetaDecorator } from 'src/views/components'
import { Pagination } from 'src/views/components'
import { costCenterContainer, teamContainer } from 'src/models'
import { CreateCostCenter } from './CreateCostCenter'
import { CostCenterTable } from './CostCenterTable'
import { filterTeamsInput } from './formInput'
import { getFilterParams, constructQueryParam } from 'src/deps'
import { IS_BROWSER } from 'src/utils'
import { i18nTranslate } from 'src/utils'
import './styles.scss'

@observer
class CostCenter extends React.Component {
  @observable isCreateCostCenterVisible = false
  @observable activePage = 1
  @observable searchCostCenter = ''
  @observable searchStatus = 'All'
  componentDidMount() {
    this.fetchCostCenterList(this.props)
  }
  handleCostCenterDetails = async data => {
    data && data.costCenterId
      ? await costCenterContainer.updateCostCenter(data)
      : await costCenterContainer.createCostCenter(data)
  }

  handleCreateCostCenter = () => {
    this.isCreateCostCenterVisible = !this.isCreateCostCenterVisible
  }

  handleDeleteCostCenter = async data => {
    await costCenterContainer.deleteCostCenter(data)
  }

  fetchCostCenterList = async filterParams => {
    if (IS_BROWSER) {
      const queryParams = getFilterParams(location)
      const params = {
        page: queryParams.page || 1,
        status: this.searchStatus,
        searchTerm: this.searchCostCenter,
        ...filterParams,
      }

      this.activePage = parseInt(params.page)
      await costCenterContainer.getAllCostCenter(params)
      await teamContainer.getAllTeams()
      await teamContainer.getAllTeamsWithoutSize()
    }
  }

  handlePagination = async pageNumber => {
    this.activePage = pageNumber
    const queryParams = getFilterParams(location)
    queryParams.page = pageNumber
    constructQueryParam(this.props, queryParams)
    this.fetchCostCenterList(this.props)
  }
  handleChangeData = value => {
    this.searchCostCenter = value
  }

  handleSearchAndFilter = filterData => {
    if (this.activePage !== 1) {
      const queryParams = this.props?.location?.queryParams || {}
      delete queryParams.page
      constructQueryParam(this.props, queryParams)
      this.activePage = 1
    }
    const { currentlySelectedType, selectTeamStatus, searchTerm } = filterData
    const params = {}
    if (currentlySelectedType === 'searchTerm') {
      this.searchStatus = 'All'
      this.searchCostCenter = searchTerm
      params.searchTerm = this.searchCostCenter
    } else {
      this.searchCostCenter = ''
      this.searchStatus =
        selectTeamStatus !== '' && selectTeamStatus !== undefined
          ? selectTeamStatus
          : 'All'
      params.selectTeamStatus =
        this.searchStatus !== 'All' ? this.searchStatus : ''
    }
    this.fetchCostCenterList(params)
  }

  render() {
    const costCenterTitle = i18nTranslate('costcenter.title', 'Cost Centers')
    const pageableInfo = costCenterContainer?.costCenterList?.pageableInfo || {}
    const { totalCount = 0, size = 0 } = pageableInfo
    const defaultSearchAndFilterValue = {
      defaultSearchStatus: this.searchStatus,
      defaulSearchCostCenter: this.searchCostCenter,
    }
    const costCenterList =
      costCenterContainer?.costCenterList?.costCentres || []
    const teamData = teamContainer?.teamsDataWithoutSize?.teams || []
    const formInput = filterTeamsInput(defaultSearchAndFilterValue)
    const myAccountCostCenterTitle = i18nTranslate(
      'myAccountCostCenterPage.title',
      'Cost Center | Nu Skin'
    )
    return (
      <>
        <MetaDecorator
          title={myAccountCostCenterTitle}
          imageUrl=""
          imageAlt=""
          description="Cost Center page"
          location={this.props}
        />
        {this.isCreateCostCenterVisible && (
          <div className="bg-white p-3 mb-2 cost-center-table">
            <h4 data-testid="qa-create-cost-center">
              {i18nTranslate(
                'myaccount.costsCenterCreateTitle',
                'Create Cost Center'
              )}
            </h4>
            <CreateCostCenter
              handleCostCenterDetails={this.handleCostCenterDetails}
              handleCreateCostCenter={this.handleCreateCostCenter}
            />
          </div>
        )}
        <div className="bg-white cost-center-table position-relative">
          {this.isCreateCostCenterVisible === false && (
            <Button
              className="costcenter-create-button"
              onClick={this.handleCreateCostCenter}>
              {i18nTranslate('costcenter.create', 'Create')}
            </Button>
          )}
          <DualDropDownWithSeachBar
            filterInput={formInput}
            title={costCenterTitle}
            onSubmit={this.handleSearchAndFilter}
            handleChangeData={this.handleChangeData}
            searchBarClassName={'cost-center-search-bar'}
          />
        </div>
        <div data-testid="qa-list-cost-center">
          <CostCenterTable
            list={costCenterList}
            teamData={teamData}
            handleDeleteCostCenter={this.handleDeleteCostCenter}
            handleCostCenterDetails={this.handleCostCenterDetails}
          />
        </div>
        {totalCount > size && (
          <Pagination
            handlePagination={this.handlePagination}
            totalPages={Math.ceil(totalCount / size)}
            active={this.activePage}
          />
        )}
      </>
    )
  }
}

export { CostCenter }

export default CostCenter
